import { Api } from "../config/request"

const CompanyApi = {
    getPositionStats(positionIds = "") {
        return Api.get(`/api/position/v1/position-stats?positionIds=${positionIds}`)
    },
    getCompanyLogo(orgId = "") {
        return Api.get(`/api/company/v1/org-logo/${orgId}`)
    },
    getUserDetails(orgId = "", phone = "") {
        return Api.get(`/api/company/v1/registration-details?organizationId=${orgId}&phone=${phone}`)
    }
}

export default CompanyApi